// gamesConfig.js - Configuración de juegos Famobi para FeelLab
// URLs formato: https://play.famobi.com/wrapper/[game-name]/A1000-10

export const gamesDatabase = [
  // Empatía Animal - Juegos relacionados con animales y cuidado
  {
    id: 'match-the-animal',
    title: 'Match The Animal',
    category: 'empatia',
    url: 'https://play.famobi.com/wrapper/match-the-animal/A1000-10',
    thumbnail: '🐾',
    description: 'Conecta animales iguales y aprende sobre diferentes especies',
    difficulty: 'Fácil',
    duration: '5-10 min',
    players: '1 jugador',
    skills: ['Reconocimiento', 'Memoria', 'Concentración'],
    ageGroup: '4+',
    featured: true,
    embedable: true
  },
  {
    id: 'animal-quiz',
    title: 'Animal Quiz',
    category: 'empatia',
    url: 'https://play.famobi.com/wrapper/animal-quiz/A1000-10',
    thumbnail: '🦁',
    description: 'Descubre y aprende sobre diferentes animales del mundo',
    difficulty: 'Medio',
    duration: '10-15 min',
    players: '1 jugador',
    skills: ['Conocimiento Animal', 'Vocabulario', 'Observación'],
    ageGroup: '6+',
    featured: true,
    embedable: true
  },
  {
    id: 'pet-roulette',
    title: 'Pet Roulette',
    category: 'empatia',
    url: 'https://play.famobi.com/wrapper/pet-roulette/A1000-10',
    thumbnail: '🐕',
    description: 'Cuida y alimenta diferentes mascotas virtuales',
    difficulty: 'Fácil',
    duration: '10-20 min',
    players: '1 jugador',
    skills: ['Cuidado', 'Responsabilidad', 'Empatía'],
    ageGroup: '5+',
    embedable: true
  },
  {
    id: 'zoo-feeder',
    title: 'Zoo Feeder',
    category: 'empatia',
    url: 'https://play.famobi.com/wrapper/zoo-feeder/A1000-10',
    thumbnail: '🦒',
    description: 'Alimenta a los animales del zoológico con la comida correcta',
    difficulty: 'Fácil',
    duration: '8-15 min',
    players: '1 jugador',
    skills: ['Cuidado Animal', 'Clasificación', 'Atención'],
    ageGroup: '4+',
    embedable: true
  },
  {
    id: 'zoo-boom',
    title: 'Zoo Boom',
    category: 'empatia',
    url: 'https://play.famobi.com/wrapper/zoo-boom/A1000-10',
    thumbnail: '🐘',
    description: 'Conecta animales del zoológico en este divertido puzzle',
    difficulty: 'Medio',
    duration: '10-25 min',
    players: '1 jugador',
    skills: ['Estrategia', 'Lógica', 'Conocimiento Animal'],
    ageGroup: '6+',
    embedable: true
  },
  {
    id: 'pets-rush',
    title: 'Pets Rush',
    category: 'empatia',
    url: 'https://play.famobi.com/wrapper/pets-rush/A1000-10',
    thumbnail: '🐱',
    description: 'Ayuda a las mascotas a encontrar su camino a casa',
    difficulty: 'Medio',
    duration: '12-20 min',
    players: '1 jugador',
    skills: ['Resolución de Problemas', 'Planificación', 'Cuidado'],
    ageGroup: '6+',
    embedable: true
  },

  // Lógica y Puzzles
  {
    id: 'hex-puzzle',
    title: 'Hex Puzzle',
    category: 'logica',
    url: 'https://play.famobi.com/wrapper/hex-puzzle/A1000-10',
    thumbnail: '🧩',
    description: 'Resuelve puzzles hexagonales desafiantes',
    difficulty: 'Medio',
    duration: '10-20 min',
    players: '1 jugador',
    skills: ['Lógica', 'Geometría', 'Paciencia'],
    ageGroup: '7+',
    featured: true,
    embedable: true
  },
  {
    id: 'blocks-puzzle-zoo',
    title: 'Blocks Puzzle Zoo',
    category: 'logica',
    url: 'https://play.famobi.com/wrapper/blocks-puzzle-zoo/A1000-10',
    thumbnail: '🦓',
    description: 'Puzzle de bloques con temática de animales del zoológico',
    difficulty: 'Fácil',
    duration: '8-15 min',
    players: '1 jugador',
    skills: ['Espacial', 'Lógica', 'Animales'],
    ageGroup: '5+',
    embedable: true
  },
  {
    id: 'onet-connect-classic',
    title: 'Onet Connect Classic',
    category: 'logica',
    url: 'https://play.famobi.com/wrapper/onet-connect-classic/A1000-10',
    thumbnail: '🔗',
    description: 'Conecta parejas de figuras idénticas en este clásico',
    difficulty: 'Medio',
    duration: '15-30 min',
    players: '1 jugador',
    skills: ['Memoria', 'Estrategia', 'Concentración'],
    ageGroup: '6+',
    embedable: true
  },
  {
    id: 'mahjong-classic',
    title: 'Mahjong Classic',
    category: 'logica',
    url: 'https://play.famobi.com/wrapper/mahjong-classic/A1000-10',
    thumbnail: '🀄',
    description: 'El juego clásico de Mahjong con diseño moderno',
    difficulty: 'Medio',
    duration: '15-35 min',
    players: '1 jugador',
    skills: ['Observación', 'Memoria', 'Estrategia'],
    ageGroup: '8+',
    embedable: true
  },
  {
    id: 'sudoku-classic',
    title: 'Sudoku Classic',
    category: 'logica',
    url: 'https://play.famobi.com/wrapper/sudoku-classic/A1000-10',
    thumbnail: '🔢',
    description: 'El puzzle de números más popular del mundo',
    difficulty: 'Difícil',
    duration: '20-45 min',
    players: '1 jugador',
    skills: ['Lógica Matemática', 'Análisis', 'Paciencia'],
    ageGroup: '10+',
    embedable: true
  },
  {
    id: 'chess-classic',
    title: 'Chess Classic',
    category: 'logica',
    url: 'https://play.famobi.com/wrapper/chess-classic/A1000-10',
    thumbnail: '♚',
    description: 'El juego de estrategia por excelencia',
    difficulty: 'Difícil',
    duration: '20-60 min',
    players: '1-2 jugadores',
    skills: ['Estrategia', 'Planificación', 'Análisis'],
    ageGroup: '8+',
    embedable: true
  },

  // Creatividad y Arte
  {
    id: 'kids-color-book',
    title: 'Kids Color Book',
    category: 'creatividad',
    url: 'https://play.famobi.com/wrapper/kids-color-book/A1000-10',
    thumbnail: '🎨',
    description: 'Libro de colorear digital con hermosos dibujos',
    difficulty: 'Fácil',
    duration: '10-25 min',
    players: '1 jugador',
    skills: ['Creatividad', 'Coordinación', 'Colores'],
    ageGroup: '3+',
    featured: true,
    embedable: true
  },
  {
    id: 'kids-tangram',
    title: 'Kids Tangram',
    category: 'creatividad',
    url: 'https://play.famobi.com/wrapper/kids-tangram/A1000-10',
    thumbnail: '🔺',
    description: 'Crea formas con piezas geométricas coloridas',
    difficulty: 'Medio',
    duration: '10-20 min',
    players: '1 jugador',
    skills: ['Geometría', 'Espacial', 'Creatividad'],
    ageGroup: '5+',
    embedable: true
  },
  {
    id: 'color-pixel-art-classic',
    title: 'Color Pixel Art Classic',
    category: 'creatividad',
    url: 'https://play.famobi.com/wrapper/color-pixel-art-classic/A1000-10',
    thumbnail: '🖼️',
    description: 'Crea arte pixel por pixel con números de colores',
    difficulty: 'Fácil',
    duration: '15-30 min',
    players: '1 jugador',
    skills: ['Arte', 'Números', 'Paciencia'],
    ageGroup: '6+',
    embedable: true
  },
  {
    id: 'mandala-coloring-book',
    title: 'Mandala Coloring Book',
    category: 'creatividad',
    url: 'https://play.famobi.com/wrapper/mandala-coloring-book/A1000-10',
    thumbnail: '🌸',
    description: 'Colorea hermosos mandalas para relajarte',
    difficulty: 'Fácil',
    duration: '15-45 min',
    players: '1 jugador',
    skills: ['Relajación', 'Arte', 'Concentración'],
    ageGroup: '6+',
    embedable: true
  },

  // Actividad Física (Coordinación y Reflejos)
  {
    id: 'tap-tap-dunk',
    title: 'Tap Tap Dunk',
    category: 'actividad',
    url: 'https://play.famobi.com/wrapper/tap-tap-dunk/A1000-10',
    thumbnail: '🏀',
    description: 'Encesta la pelota con toques precisos',
    difficulty: 'Medio',
    duration: '5-15 min',
    players: '1 jugador',
    skills: ['Coordinación', 'Timing', 'Precisión'],
    ageGroup: '6+',
    embedable: true
  },
  {
    id: 'slope',
    title: 'Slope',
    category: 'actividad',
    url: 'https://play.famobi.com/wrapper/slope/A1000-10',
    thumbnail: '⚽',
    description: 'Rueda la pelota por pendientes infinitas',
    difficulty: 'Medio',
    duration: '5-20 min',
    players: '1 jugador',
    skills: ['Reflejos', 'Control', 'Concentración'],
    ageGroup: '7+',
    featured: true,
    embedable: true
  },
  {
    id: 'penalty-shooters-2',
    title: 'Penalty Shooters 2',
    category: 'actividad',
    url: 'https://play.famobi.com/wrapper/penalty-shooters-2/A1000-10',
    thumbnail: '⚽',
    description: 'Marca goles y para penaltis como un campeón',
    difficulty: 'Medio',
    duration: '10-25 min',
    players: '1-2 jugadores',
    skills: ['Precisión', 'Timing', 'Competencia'],
    ageGroup: '6+',
    embedable: true
  },
  {
    id: 'basketball',
    title: 'Basketball',
    category: 'actividad',
    url: 'https://play.famobi.com/wrapper/basketball/A1000-10',
    thumbnail: '🏀',
    description: 'Juego de baloncesto con física realista',
    difficulty: 'Medio',
    duration: '8-20 min',
    players: '1 jugador',
    skills: ['Coordinación', 'Ángulos', 'Práctica'],
    ageGroup: '6+',
    embedable: true
  },

  // Música y Sonidos
  {
    id: 'perfect-piano',
    title: 'Perfect Piano',
    category: 'musica',
    url: 'https://play.famobi.com/wrapper/perfect-piano/A1000-10',
    thumbnail: '🎹',
    description: 'Aprende a tocar melodías en un piano virtual',
    difficulty: 'Fácil',
    duration: '10-30 min',
    players: '1 jugador',
    skills: ['Música', 'Ritmo', 'Coordinación'],
    ageGroup: '4+',
    featured: true,
    embedable: true
  },
  {
    id: 'piano-steps',
    title: 'Piano Steps',
    category: 'musica',
    url: 'https://play.famobi.com/wrapper/piano-steps/A1000-10',
    thumbnail: '🎼',
    description: 'Sigue el ritmo tocando las teclas correctas',
    difficulty: 'Medio',
    duration: '5-15 min',
    players: '1 jugador',
    skills: ['Ritmo', 'Velocidad', 'Coordinación'],
    ageGroup: '6+',
    embedable: true
  },

  // Juegos Adicionales de Emociones y Cuidado
  {
    id: 'kids-puzzle-adventure',
    title: 'Kids Puzzle Adventure',
    category: 'empatia',
    url: 'https://play.famobi.com/wrapper/kids-puzzle-adventure/A1000-10',
    thumbnail: '🧩',
    description: 'Aventura de puzzles explorando diferentes hábitats',
    difficulty: 'Fácil',
    duration: '15-25 min',
    players: '1 jugador',
    skills: ['Exploración', 'Formas', 'Naturaleza'],
    ageGroup: '4+',
    embedable: true
  },
  {
    id: 'bubble-woods',
    title: 'Bubble Woods',
    category: 'naturaleza',
    url: 'https://play.famobi.com/wrapper/bubble-woods/A1000-10',
    thumbnail: '🌳',
    description: 'Dispara burbujas en un bosque mágico',
    difficulty: 'Fácil',
    duration: '10-20 min',
    players: '1 jugador',
    skills: ['Precisión', 'Colores', 'Naturaleza'],
    ageGroup: '5+',
    embedable: true
  },
  {
    id: 'garden-bloom',
    title: 'Garden Bloom',
    category: 'naturaleza',
    url: 'https://play.famobi.com/wrapper/garden-bloom/A1000-10',
    thumbnail: '🌺',
    description: 'Cuida un jardín lleno de flores hermosas',
    difficulty: 'Fácil',
    duration: '12-25 min',
    players: '1 jugador',
    skills: ['Cuidado', 'Colores', 'Paciencia'],
    ageGroup: '4+',
    embedable: true
  },
  {
    id: 'butterfly-shimai',
    title: 'Butterfly Shimai',
    category: 'naturaleza',
    url: 'https://play.famobi.com/wrapper/butterfly-shimai/A1000-10',
    thumbnail: '🦋',
    description: 'Conecta mariposas idénticas en este hermoso juego',
    difficulty: 'Medio',
    duration: '10-20 min',
    players: '1 jugador',
    skills: ['Memoria', 'Observación', 'Naturaleza'],
    ageGroup: '5+',
    embedable: true
  },

  // Juegos de Cartas y Mesa Familiares
  {
    id: 'solitaire-classic',
    title: 'Solitaire Classic',
    category: 'logica',
    url: 'https://play.famobi.com/wrapper/solitaire-classic/A1000-10',
    thumbnail: '🃏',
    description: 'El juego de cartas solitario más popular',
    difficulty: 'Medio',
    duration: '10-25 min',
    players: '1 jugador',
    skills: ['Estrategia', 'Paciencia', 'Secuencias'],
    ageGroup: '8+',
    embedable: true
  },
  {
    id: 'checkers-classic',
    title: 'Checkers Classic',
    category: 'logica',
    url: 'https://play.famobi.com/wrapper/checkers-classic/A1000-10',
    thumbnail: '⚫',
    description: 'El clásico juego de damas para dos jugadores',
    difficulty: 'Medio',
    duration: '15-30 min',
    players: '1-2 jugadores',
    skills: ['Estrategia', 'Planificación', 'Táctica'],
    ageGroup: '7+',
    embedable: true
  },
  {
    id: 'dominoes-classic',
    title: 'Dominoes Classic',
    category: 'logica',
    url: 'https://play.famobi.com/wrapper/dominoes-classic/A1000-10',
    thumbnail: '🁹',
    description: 'Juego tradicional de dominó con reglas clásicas',
    difficulty: 'Medio',
    duration: '15-35 min',
    players: '1-4 jugadores',
    skills: ['Matemáticas', 'Estrategia', 'Observación'],
    ageGroup: '7+',
    embedable: true
  }
];

// Categorías optimizadas para FeelLab
export const gameCategories = [
  {
    id: 'todas',
    name: 'Todos los Juegos',
    icon: 'FaGamepad',
    color: 'from-sky-400 to-emerald-400',
    description: 'Explora todos nuestros juegos educativos'
  },
  {
    id: 'empatia',
    name: 'Empatía Animal',
    icon: 'FaHeart',
    color: 'from-pink-400 to-rose-400',
    description: 'Aprende sobre el cuidado y amor hacia los animales'
  },
  {
    id: 'logica',
    name: 'Lógica y Puzzles',
    icon: 'FaBrain',
    color: 'from-emerald-400 to-teal-400',
    description: 'Desarrolla tu pensamiento lógico y resolución de problemas'
  },
  {
    id: 'creatividad',
    name: 'Arte y Creatividad',
    icon: 'FaPuzzlePiece',
    color: 'from-teal-400 to-emerald-400',
    description: 'Expresa tu lado artístico y creativo'
  },
  {
    id: 'actividad',
    name: 'Coordinación',
    icon: 'FaRunning',
    color: 'from-amber-400 to-orange-400',
    description: 'Juegos que desarrollan coordinación y reflejos'
  },
  {
    id: 'musica',
    name: 'Música',
    icon: 'FaMusic',
    color: 'from-emerald-400 to-teal-500',
    description: 'Explora el mundo de la música y los sonidos'
  },
  {
    id: 'naturaleza',
    name: 'Naturaleza',
    icon: 'FaLeaf',
    color: 'from-green-400 to-emerald-400',
    description: 'Conecta con la naturaleza y el medio ambiente'
  }
];

// Funciones de utilidad
export const getGamesByCategory = (category) => {
  if (category === 'todas') return gamesDatabase;
  return gamesDatabase.filter(game => game.category === category);
};

export const getFeaturedGames = () => {
  return gamesDatabase.filter(game => game.featured);
};

export const getGameById = (id) => {
  return gamesDatabase.find(game => game.id === id);
};

export const getGamesByAgeGroup = (minAge) => {
  return gamesDatabase.filter(game => {
    const gameAge = parseInt(game.ageGroup.replace('+', ''));
    return gameAge <= minAge;
  });
};

export const getGamesByDifficulty = (difficulty) => {
  return gamesDatabase.filter(game => game.difficulty === difficulty);
};

export const searchGames = (searchTerm) => {
  const term = searchTerm.toLowerCase();
  return gamesDatabase.filter(game => 
    game.title.toLowerCase().includes(term) ||
    game.description.toLowerCase().includes(term) ||
    game.skills.some(skill => skill.toLowerCase().includes(term))
  );
};

// Función para agregar nuevos juegos
export const addNewGame = (gameData) => {
  const newGame = {
    id: gameData.id || `game-${Date.now()}`,
    title: gameData.title,
    category: gameData.category,
    url: gameData.url,
    thumbnail: gameData.thumbnail || '🎮',
    description: gameData.description,
    difficulty: gameData.difficulty || 'Fácil',
    duration: gameData.duration || '10-20 min',
    players: gameData.players || '1 jugador',
    skills: gameData.skills || [],
    ageGroup: gameData.ageGroup || '6+',
    featured: gameData.featured || false,
    embedable: gameData.embedable !== false // Por defecto true
  };
  
  gamesDatabase.push(newGame);
  return newGame;
};

// URLs de respaldo para juegos críticos
export const fallbackUrls = {
  'match-the-animal': 'https://www.memozor.com/memory-games/for-kids/memory-animals',
  'animal-quiz': 'https://www.coolmathgames.com/0-animal-quiz',
  'hex-puzzle': 'https://www.cokogames.com/hex-puzzle/',
  'kids-color-book': 'https://www.cokogames.com/kids-coloring-book/'
};

export const getAlternativeUrl = (gameId) => {
  return fallbackUrls[gameId] || null;
};

// Juegos recomendados por edad
export const gameRecommendationsByAge = {
  '3-5': ['kids-color-book', 'match-the-animal', 'perfect-piano', 'garden-bloom'],
  '6-8': ['animal-quiz', 'kids-tangram', 'bubble-woods', 'tap-tap-dunk'],
  '9-12': ['hex-puzzle', 'chess-classic', 'slope', 'onet-connect-classic'],
  '13+': ['sudoku-classic', 'mahjong-classic', 'checkers-classic', 'dominoes-classic']
};

export const getRecommendedGames = (ageRange) => {
  const gameIds = gameRecommendationsByAge[ageRange] || [];
  return gameIds.map(id => getGameById(id)).filter(Boolean);
};